import { Card } from "antd";
import React from "react";

export default function LocationPanel() {
  return (
    <div className="w-full px-2">
      <Card className="bg-gray-50/70 border-gray-200 shadow-sm rounded-xl overflow-hidden flex flex-col w-full">
        {/* Google Map */}
        <div className="w-full h-[520px] md:h-[600px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.7197673713326!2d55.3069501!3d25.2453779!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f42d5daeab927%3A0xfdc87d85f9e5af4e!2sKarama%20Medical%20Fitness%20Express%20Service%20Center%20-%20KMFC!5e0!3m2!1sen!2sae!4v1698231234567!5m2!1sen!2sae"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            title="Dubai Map"
          ></iframe>
        </div>
      </Card>
    </div>
  );
}
